module.exports = __webpack_public_path__ + "static/img/introduce_bottom6.7d2f02aa.png";